import { Component } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "backoffice-client";
  private isLoaded = false;

  isChatOpen = false;

  toggleChat(): void {
    this.isChatOpen = !this.isChatOpen;
    if (this.isChatOpen && !this.isLoaded) {
      this.loadTawk();
    }
  }

  loadTawk(): void {
    if (this.isLoaded) return;

    (window as any).Tawk_API = (window as any).Tawk_API || {};
    (window as any).Tawk_LoadStart = new Date();

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = "https://embed.tawk.to/6871f2a0d98e57190d02728b/1ivuhnhem";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");

    s1.onload = () => {
      // render inside our floating container
      (window as any).Tawk_API.embedded = "tawk-container";
    };

    document.body.appendChild(s1);
    this.isLoaded = true;
  }
}
